import { useSelector } from 'react-redux'

import { RootState } from '../store'

const useContentsSelector = () => useSelector((state: RootState) => state.contentModel.contentData)

const useContentFilesSelector = () =>
  useSelector((state: RootState) => state.contentModel.contentFilesData)

const useCurrentFolderSelector = () =>
  useSelector((state: RootState) => state.contentModel.currentFolder)

const useContentLoadingSelector = () =>
  useSelector((state: RootState) => state.contentModel.isContentLoading)

const usePermissionsLoadedSelector = () =>
  useSelector((state: RootState) => state.contentModel.permissionsLoaded)

const useAgentLoadingSelector = () =>
  useSelector((state: RootState) => state.contentModel.isAgentLoading)

const useInnerContentLoadingSelector = () =>
  useSelector((state: RootState) => state.contentModel.isInnerContentLoading)

const usePromtTemplateSelector = () =>
  useSelector((state: RootState) => state.contentModel.templatesData)

const usePromptHistorySelector = () =>
  useSelector((state: RootState) => state.contentModel.promptHistory)

const useChatMessageSelector = () =>
  useSelector((state: RootState) => state.contentModel.chatMessage)

const useLLMModelSelector = () => useSelector((state: RootState) => state.contentModel.llmModelList)

const useLLMModelListForSettingsSelector = () =>
  useSelector((state: RootState) => state.contentModel.llmModelListForSettings)

const useLlmConfigMutatingSelector = () =>
  useSelector((state: RootState) => state.contentModel.isLlmConfigMutating)

const usePromptDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.promptData)

const useappDataSelector = () => useSelector((state: RootState) => state.contentModel.appData)

const useAppDesignDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.appDesignerData)

const useCurrentAppDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.currentAppDetails)
const useParsedResponse = () =>
  useSelector((state:RootState)=> state.contentModel.parsedResponse)

const useTestStatusSelector = () => useSelector((state: RootState) => state.contentModel.testStatus)

const useQuerySelector = () => useSelector((state: RootState) => state.contentModel.queryUrl)

const useAppHistorySelector = () => useSelector((state: RootState) => state.contentModel.appHistory)

const useAppVersionSelector = () =>
  useSelector((state: RootState) => state.contentModel.appVersions)

const useAppStatusSelector = () =>
  useSelector((state: RootState) => state.contentModel.bulkRunStatus)

const useBulkRunstatus = () =>
  useSelector((state: RootState) => state.contentModel.isBulkRunContentLoading)

const useRunHistorySelector = () => useSelector((state: RootState) => state.contentModel.runHistory)

const useTagsSelector = () => useSelector((state: RootState) => state.contentModel.Tags)

const useAppShareLinkGeneration = () =>
  useSelector((state: RootState) => state.contentModel.appShareLinkGeneration)
// const usePromptTagsSelector = ()=>
// useSelector((state:RootState)=>state.contentModel.promptTags)

const useAppShareLinkValidation = () =>
  useSelector((state: RootState) => state.contentModel.appShareLinkValidation)
const useBulkRunResultDynamic = () =>
  useSelector((state: RootState) => state.contentModel.bulkRunResultDynamic)

const useVisionModelSelector = () =>
  useSelector((state: RootState) => state.contentModel.visionModelList)

const useFileParams = () => useSelector((state: RootState) => state.contentModel.fileParams)

const useenduserresult = () => useSelector((state: RootState) => state.contentModel.enduserresult)
const useAppApiUrl = () => useSelector((state: RootState) => state.contentModel.appApiUrl)
const useUpdatedUrlforCsvUpload = () =>
  useSelector((state: RootState) => state.contentModel.updatedUrlforCsvUpload)
const useDownloadLoadingSelector = () => useSelector((state: RootState) => state.contentModel.downloadLoading)
const useAutosolverunbatchLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isAutosolverunbatchLoading)
const useDownloadCsvReportAgentAssist = () =>
  useSelector((state: RootState) => state.contentModel.updatedUrlforCsvUpload)
const useVectorDb = () => useSelector((state: RootState) => state.contentModel.vectorDB)
const useUserListSelector = () => useSelector((state: RootState) => state.contentModel.userList)
const useEmailInviteSelector = () => useSelector((state: RootState) => state.contentModel.emailInvite)
const useGetUSerDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.userDetails)
const useListTenantSelector = () => useSelector((state: RootState) => state.contentModel.tenantList)
const useListSchedulerSelectors = ()=>useSelector((state:RootState)=>state.contentModel.SchedulerList)
const useListRolesSelectors = () => useSelector((state: RootState) => state.contentModel.rolesList)
const useListAccessSelectors = () =>
  useSelector((state: RootState) => state.contentModel.accessList)
const useWorkspaceAccessSelectors = () =>
  useSelector((state: RootState) => state.contentModel.workspaceAccessList)
const useGetTenantDetails = () =>
  useSelector((state: RootState) => state.contentModel.tenantDetails)
const usePermissionValues = () =>
  useSelector((state: RootState) => state.contentModel.permissionValues)
const useListPackagesSelectors = () =>
  useSelector((state: RootState) => state.contentModel.packageList)
const useListProductsSelectors = () =>
  useSelector((state: RootState) => state.contentModel.productList)
const useGetViewUserSelector = () => useSelector((state: RootState) => state.contentModel.viewUser)
const useGetIntegrationList = () =>
  useSelector((state: RootState) => state.contentModel.integrationList)
const useGetMasterIntegrationList = () =>
  useSelector((state: RootState) => state.contentModel.masterIntegrationList)
const useFeatureSettingSelector = () =>
  useSelector((state: RootState) => state.contentModel.featureSettings)
const useAutosolveDashboardSelector = () =>
  useSelector((state: RootState) => state.contentModel.autosolveDashboard)
const useAgentAssistDashboardSelector = () =>
  useSelector((state: RootState) => state.contentModel.agentAssistDashboard)
const useWorkflowDashboardSelector = () =>
  useSelector((state: RootState) => state.contentModel.workflowDashboard)
const useHomeDashboardTotalSelector = () =>
  useSelector((state: RootState) => state.contentModel.homeDashboardTotal)
const useTicketDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.ticketDetail)
const useAutoTagListSelector = () =>
  useSelector((state: RootState) => state.contentModel.autoTagData)


const useAgentTagListSelector = () =>
  useSelector((state: RootState) => state.contentModel.agentTagData)
const useendPointDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.endpointdata)
const useTenantTeamSelectors = () =>
  useSelector((state: RootState) => state.contentModel.tenantGroup)
const useLoaderSelector = () => useSelector((state: RootState) => state.contentModel.loader)
const useFaqDataSelector = () => useSelector((state: RootState) => state.contentModel.faqData)
const usePastTicketDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.pastTicketData)
const useAgentAssistAppSelector = () =>
  useSelector((state: RootState) => state.contentModel.agentAssistApps)
const useFaqPtTicketDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.ticketFaqPtDetails)
const useEmbeddingModelListSelector = () =>
  useSelector((state: RootState) => state.contentModel.embeddingModelList)
const useCxAutosolveFilterSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAutosolveFilter)
const useCxAutosolveDownloadSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAutosolveDownload)
const useCxAutosolveHistoryDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAutosolveHistoryData)

const useSingleConversationDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.singleConversationData)
const useCxAutosolveFourCardsSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAutosolveFourCards)
const useLiveAgentNotificationSelector = () =>
  useSelector((state: RootState) => state.contentModel.liveAgentNotifications)
const useSubscriptionDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.subscriptionDetails)
const useCxAgentAssistFilterSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAgentAssistFilter)
const useCxAgentAssistDownloadSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAgentAssistDownload)
const useCxAgentAssistHistoryDataSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAgentAssistHistoryData)
const useCxAgentAssistHistorySelected = () =>
  useSelector((state: RootState) => state.contentModel.cxAgentAssistHistorySelected)
const useCxAgentAssistCardDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.cxAgentAssistCardDetails)  
const useTopIntentsSelector = () => useSelector((state: RootState) => state.contentModel.topIntents)
const useAppIdSelector = () => useSelector((state: RootState) => state.contentModel.appId)

const useTopIncreasedIntentsSelector = () =>
  useSelector((state: RootState) => state.contentModel.topIncreasedIntents)

const useTopDecreasedIntentsSelector = () =>
  useSelector((state: RootState) => state.contentModel.topDecreasedIntents)

const useTotalIntentsSelector = () =>
  useSelector((state: RootState) => state.contentModel.topTotalIntents)

const useTicketsBasedonIntent = () =>
  useSelector((state: RootState) => state.contentModel.ticketsBasedonIntent)

const useGetCurrentModule = () =>
  useSelector((state: RootState) => state.contentModel.currentModule)
const useIntentsGraphData = () =>
  useSelector((state: RootState) => state.contentModel.intentsGraphData)

const useIntentsListData = () => useSelector((state: RootState) => state.contentModel.intentLists)

const useTimetoResponse = () => useSelector((state: RootState) => state.contentModel.timetoResponse)

const useTimetoResolve = () => useSelector((state: RootState) => state.contentModel.timetoResolve)

const useTicketEscallation = () =>
  useSelector((state: RootState) => state.contentModel.ticketEscallation)

const useFirstContactResolution = () =>
  useSelector((state: RootState) => state.contentModel.firstContactResolution)

const useCommonTags = () => useSelector((state: RootState) => state.contentModel.commonTags)

const useCustomerHealthSelector = () =>
  useSelector((state: RootState) => state.contentModel.customerHealth)
const useChatBotHistorySelector = () =>
  useSelector((state: RootState) => state.contentModel.chatBotHistory)

const useListAllIntents = () => useSelector((state: RootState) => state.contentModel.allIntents)

const useControlroomFilter = () =>
  useSelector((state: RootState) => state.contentModel.controlroomFilter)

const useAppInsights = () => useSelector((state: RootState) => state.contentModel.appInsights)


const useBotDetailsSelector = () => useSelector((state: RootState) => state.contentModel.botDetails)
const useWidgetListSelector = () => useSelector((state: RootState) => state.contentModel.widgetList)
const useIsListWidgetsLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isListWidgetsLoading)
const useWidgetHistory = () => useSelector((state: RootState) => state.contentModel.widgetHistoryDetails)

const useWidgetTypesSelector = () =>
  useSelector((state: RootState) => state.contentModel.widgetTypes)
const useAgentListSelector = () => useSelector((state: RootState) => state.contentModel.agentList)
const useAgentVersionsSelector = () => useSelector((state: RootState) => state.contentModel.agentVersions)

const useSelectedToolsSelector = () =>
  useSelector((state: RootState) => state.contentModel.selectedTools)

const useGetWidgetDetails = () =>
  useSelector((state: RootState) => state.contentModel.widgetDetails)

const useGetWidgetObjectDetails = () =>
  useSelector((state: RootState) => state.contentModel.WidgetObjectDetails)

const useGetActiveEnterPriseHubList = () =>
  useSelector((state: RootState) => state.contentModel.EnterPriseHubList)

const useGetExHubHistoryList = () =>
  useSelector((state: RootState) => state.contentModel.ExHubHistoryList)

const useGetTrustforteList = () =>
  useSelector((state: RootState) => state.contentModel.trustforteList)

const useAutoSolveRunHistory = () =>
  useSelector((state: RootState) => state.contentModel.AutosolveRunHistory)

const useAutoSolveRunHistoryConversations = () =>
  useSelector((state: RootState) => state.contentModel.AutosolveRunHistoryConversations)
const useAgentConversationsList = () =>
  useSelector((state: RootState) => state.contentModel.agentConversationList)
const useAgentConversationDetail = () =>
  useSelector((state: RootState) => state.contentModel.agentConversationDetail)
const useAgentAssistFilterDetails = () =>
  useSelector((state: RootState) => state.contentModel.agentAssistFilterDetails)
const useGetInstalltionListSelector = () =>
  useSelector((state: RootState) => state.contentModel.installationList)

const useGenerateCodeSelector = () =>useSelector((state: RootState) => state.contentModel.generateCode)
const useGetFileUrl = () =>useSelector((state: RootState) => state.contentModel.fileURL)
const useOrganizationSummaryDriverFilter = () => useSelector((state: RootState) => state.contentModel.organizationSummaryDriverFilter)
const useControlRoomFilterSelect = () => useSelector((state: RootState) => state.contentModel.controlRoomFiltersList)


const useChatBotHistoryLoaderSelector = ()=>
  useSelector((state:RootState)=> state.contentModel.isChatBotHistoryLoader)

const useLearnMoreSelector = ()=>
  useSelector((state:RootState)=> state.contentModel.learnMore)

const useTerminateApiUrlSelector = ()=>
  useSelector((state:RootState)=> state.contentModel.terminateUrl)
const useTerminateBulkrunforAutoSolveSelector = ()=>
  useSelector((state:RootState)=> state.contentModel.terminateBulkrunforAutoSolve)

const useCleanupResponseSelector=()=>
  useSelector((state:RootState)=>state.contentModel.cleanupResponse)

const useAutosolveConversationDetail = () => useSelector((state: RootState) => state.contentModel.autoSolveConversationDetail)
const useAgentDetails = () => useSelector((state: RootState) => state.contentModel.agentDetails)
const useAutoSolveMetaData=()=> useSelector((state: RootState)=> state.contentModel.autosolveMetaData)
const useTotalConversationCountSelector = () => useSelector((state: RootState) => state.contentModel.totalConversationCount)
const useTotalUpVoteCountSelector = () => useSelector((state: RootState) => state.contentModel.totalUpvoteCount)
const useTotalDownVoteCountSelector = () => useSelector((state: RootState) => state.contentModel.totalDownvoteCount)
const useAgentTotalConversationCountSelector = () => useSelector((state: RootState) => state.contentModel.agentTotalConversationCount)
const useAgentTotalUpvoteCountSelector = () => useSelector((state: RootState) => state.contentModel.agentTotalUpvoteCount)
const useAgentTotalDownvoteCountSelector = () => useSelector((state: RootState) => state.contentModel.agentTotalDownvoteCount)
const useSasTokenSelector = () => useSelector((state: RootState) => state.contentModel.sasToken)
const useFileUploadLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isfileLoading)
const useRoleMappedCountSelectors = () => useSelector((state: RootState) => state.contentModel.userMappedRoles)
const useCreateScheduler = () => useSelector((state: RootState) => state.contentModel.createScheduler)

const useMasterDataSelector = () => useSelector((state: RootState) => state.contentModel.masterData)
const useCurrentPublishedAppDetailsSelector = () =>
  useSelector((state: RootState) => state.contentModel.currentPublishedAppDetails)
const useAutosolveTestHistorySelector = () => useSelector((state: RootState) => state.contentModel.autosolveTestHistory)
const useBlockLevelHistorySelector = () => useSelector((state: RootState) => state.contentModel.blockLevelHistory)
const usePinotQueryDataSelector = () => useSelector((state: RootState) => state.contentModel.pinotQueryData)
const useNaturalLanguageQueryTranslationSelector = () => useSelector((state: RootState) => state.contentModel.naturalLanguageQueryTranslation)
const useSchedulerHistorySelector = () => useSelector((state: RootState) => state.contentModel.schedulerHistory)
const useUploadFilesConfluenceSelector = () => useSelector((state: RootState) => state.contentModel.uploadFilesConfluence)
const useUploadFilesSharePointSelector = () => useSelector((state: RootState) => state.contentModel.uploadFilesSharePoint)
const useUploadFilesSlackSelector = () => useSelector((state: RootState) => state.contentModel.uploadFilesSlack)
const useUploadFilesSlackChannelsSelector = () => useSelector((state: RootState) => state.contentModel.uploadFilesSlackChannels)
const usePinotQueryLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isPinotQueryLoading)
const useBotContentLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isBotLoading)
const useCustomFieldSelector = () => useSelector((state: RootState) => state.contentModel.customField)
const useAutoSolveBlockLevelHistorySelector = () => useSelector((state: RootState) => state.contentModel.autoSolveBlockLevelHistory)
const useFileuploadBulkrunSelector = () => useSelector((state: RootState) => state.contentModel.fileuploadBulkrun)
const useAutosolverunbatchSelector = () => useSelector((state: RootState) => state.contentModel.autosolverunbatch)
const useConfluenceDataSelector = () => useSelector((state: RootState) => state.contentModel.confluenceData)
const useRealTimeAudioSelector = () => useSelector((state: RootState) => state.contentModel.realTimeAudio)

// Seeker selectors
const useCxSeekerFilterSelector = () => useSelector((state: RootState) => state.contentModel.cxSeekerFilter)
const useCxSeekerDownloadSelector = () => useSelector((state: RootState) => state.contentModel.cxSeekerDownload)
const useCxSeekerCardDetailsSelector = () => useSelector((state: RootState) => state.contentModel.cxSeekerCardDetails)
const useCxSeekerHistoryDataSelector = () => useSelector((state: RootState) => state.contentModel.cxSeekerHistoryData)
const useIsSeekerCardsLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isSeekerCardsLoading)
const useIsSeekerTableLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isSeekerTableLoading)
const useIsAgentAssistCardsLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isAgentAssistCardsLoading)
const useIsAgentAssistTableLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isAgentAssistTableLoading)
const useIsAppInsightsLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isAppInsightsLoading)
const useIsKnowledgeBaseListFolderLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isKnowledgeBaseListFolderLoading)
const useIsPastTicketsListFolderLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isPastTicketsListFolderLoading)
const useSeekerFeedbackUpdateSelector = () => useSelector((state: RootState) => state.contentModel.seekerFeedbackUpdate)
const useCxSeekerConversationDetailsSelector = () => useSelector((state: RootState) => state.contentModel.cxSeekerConversationDetails)
const useCxSeekerPinotQueryResultsSelector = () => useSelector((state: RootState) => state.contentModel.cxSeekerPinotQueryResults)
const useIsSeekerConversationLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isSeekerConversationLoading)
const useIsSeekerPinotQueryLoadingSelector = () => useSelector((state: RootState) => state.contentModel.isSeekerPinotQueryLoading)
const useGetAlertsListSelector = () => useSelector((state: RootState) => state.contentModel.alertsList)
const useGetReportsListSelector  = () => useSelector((state: RootState) => state.contentModel.reportsList)
const useAgentsListsForApp = () => useSelector((state: RootState) => state.contentModel.agentListForApp)
const useTrustforteMailDocumentData = () => useSelector((state: RootState) => state.contentModel.TrustforteDocumentData)
const useDatabaseListSelector = () => useSelector((state: RootState) => state.contentModel.databaseList)

const useTemplateListSelector = () =>
  useSelector((state: RootState) => (state.contentModel as any).templateList)
const useTemplateDetailsSelector = () =>
  useSelector((state: RootState) => (state.contentModel as any).templateDetails)

const useEvalDatasetsSelector = () => useSelector((state: RootState) => state.contentModel.evalDatasets)
const useEvalHistorySelector = () => useSelector((state: RootState) => (state.contentModel as any).evalHistory)

export {
  useAgentAssistAppSelector,
  useContentsSelector,
  useContentFilesSelector,
  useCurrentFolderSelector,
  useContentLoadingSelector,
  usePromtTemplateSelector,
  usePromptHistorySelector,
  useChatMessageSelector,
  useLLMModelSelector,
  useLLMModelListForSettingsSelector,
  useLlmConfigMutatingSelector,
  usePromptDetailsSelector,
  useappDataSelector,
  useAppDesignDataSelector,
  useCurrentAppDetailsSelector,
  useTestStatusSelector,
  useQuerySelector,
  useAppHistorySelector,
  useAppVersionSelector,
  useAppStatusSelector,
  useBulkRunstatus,
  useRunHistorySelector,
  useTagsSelector,
  useAppShareLinkGeneration,
  useAppShareLinkValidation,
  useBulkRunResultDynamic,
  useVisionModelSelector,
  useFileParams,
  useenduserresult,
  useAppApiUrl,
  useUpdatedUrlforCsvUpload,
  useVectorDb,
  useUserListSelector,
  useGetUSerDetailsSelector,
  useListTenantSelector,
  useListRolesSelectors,
  useListAccessSelectors,
  useWorkspaceAccessSelectors,
  useGetTenantDetails,
  usePermissionValues,
  useListPackagesSelectors,
  useListProductsSelectors,
  useGetViewUserSelector,
  useGetIntegrationList,
  useGetMasterIntegrationList,
  useFeatureSettingSelector,
  useAutosolveDashboardSelector,
  useAgentAssistDashboardSelector,
  useWorkflowDashboardSelector,
  useHomeDashboardTotalSelector,
  useTicketDetailsSelector,
  useAutoTagListSelector,
  useendPointDataSelector,
  useTenantTeamSelectors,
  useLoaderSelector,
  useFaqDataSelector,
  usePastTicketDataSelector,
  useFaqPtTicketDataSelector,
  useEmbeddingModelListSelector,
  useSubscriptionDetailsSelector,
  useTopIntentsSelector,
  useTotalIntentsSelector,
  useTopIncreasedIntentsSelector,
  useTopDecreasedIntentsSelector,
  useTicketsBasedonIntent,
  useGetCurrentModule,
  useIntentsGraphData,
  useIntentsListData,
  useTimetoResponse,
  useTimetoResolve,
  useTicketEscallation,
  useFirstContactResolution,
  useCommonTags,
  useCustomerHealthSelector,
  useListAllIntents,
  useChatBotHistorySelector,
  useControlroomFilter,
  useAppInsights,
  useBotDetailsSelector,
  useWidgetListSelector,
  useIsListWidgetsLoadingSelector,
  useWidgetTypesSelector,
  useAgentListSelector,
  useAgentVersionsSelector,
  useSelectedToolsSelector,
  useGetWidgetDetails,
  useAutoSolveRunHistory,
  useAutoSolveRunHistoryConversations,
  useInnerContentLoadingSelector,
  useAgentConversationsList,
  useAgentConversationDetail,
  useListSchedulerSelectors,
  useGetInstalltionListSelector,
  useGenerateCodeSelector,
  useChatBotHistoryLoaderSelector,
  useLearnMoreSelector,
  useTerminateApiUrlSelector,
  useCleanupResponseSelector,
  useAutosolveConversationDetail,
  useAgentDetails,
  useGetFileUrl,
  useOrganizationSummaryDriverFilter,
  useAutoSolveMetaData,
  useWidgetHistory,
  useAgentTagListSelector,
  useTotalConversationCountSelector,
  useTotalUpVoteCountSelector,
  useTotalDownVoteCountSelector,
  useAgentTotalConversationCountSelector, 
  useAgentTotalUpvoteCountSelector,
  useAgentTotalDownvoteCountSelector,
  useSasTokenSelector,
  useFileUploadLoadingSelector,
  useRoleMappedCountSelectors,
  useCreateScheduler,
  useMasterDataSelector,
  useAgentAssistFilterDetails,
  usePinotQueryDataSelector,
  useNaturalLanguageQueryTranslationSelector,
  useAgentLoadingSelector,
  useAppIdSelector,
  usePinotQueryLoadingSelector,
  useParsedResponse,
  useBlockLevelHistorySelector,
  useDownloadCsvReportAgentAssist,
  useSchedulerHistorySelector,  
  useUploadFilesConfluenceSelector,
  useUploadFilesSharePointSelector,
  useBotContentLoadingSelector,
  useDownloadLoadingSelector,
  useUploadFilesSlackSelector,
  useUploadFilesSlackChannelsSelector,
  useCustomFieldSelector,
  useAutoSolveBlockLevelHistorySelector,
  useFileuploadBulkrunSelector,
  useAutosolverunbatchSelector,
  useAutosolverunbatchLoadingSelector,
  useTerminateBulkrunforAutoSolveSelector,
  useConfluenceDataSelector,
  useGetWidgetObjectDetails,
  useGetActiveEnterPriseHubList,
  useGetExHubHistoryList,
  useAutosolveTestHistorySelector,
  useEmailInviteSelector,
  useRealTimeAudioSelector,
  useCxAutosolveFilterSelector,
  useCxAutosolveDownloadSelector,
  useCxAutosolveHistoryDataSelector, 
  useLiveAgentNotificationSelector,
  useCxAgentAssistFilterSelector,
  useCxAgentAssistDownloadSelector,
  useCxAgentAssistHistoryDataSelector,
  useCxAgentAssistHistorySelected,
  useCxAgentAssistCardDetailsSelector,
  useSingleConversationDataSelector,
  useCxAutosolveFourCardsSelector,
  useCxSeekerFilterSelector,
  useCxSeekerDownloadSelector,
  useCxSeekerCardDetailsSelector,
  useCxSeekerHistoryDataSelector,
  useIsSeekerCardsLoadingSelector,
  useIsSeekerTableLoadingSelector,
  useIsAgentAssistCardsLoadingSelector,
  useIsAgentAssistTableLoadingSelector,
  useIsKnowledgeBaseListFolderLoadingSelector,
  useIsPastTicketsListFolderLoadingSelector,
  useIsAppInsightsLoadingSelector,
  useSeekerFeedbackUpdateSelector,
  useCxSeekerConversationDetailsSelector,
  useCxSeekerPinotQueryResultsSelector,
  useIsSeekerConversationLoadingSelector,
  useIsSeekerPinotQueryLoadingSelector,
  useGetAlertsListSelector,
  useGetReportsListSelector,
  useGetTrustforteList,
  useAgentsListsForApp,
  useControlRoomFilterSelect,
  useCurrentPublishedAppDetailsSelector,
  useTrustforteMailDocumentData,
  useDatabaseListSelector,
  useTemplateListSelector,
  useTemplateDetailsSelector,
  useEvalDatasetsSelector,
  useEvalHistorySelector,
  usePermissionsLoadedSelector
}
